export enum EnumFontStyle {
	BOLD = 'bold',
	LIGHT = 'light',
	REGULAR = 'regular',
	SEMIBOLD = 'semi-bold',
	SOLID = 'solid',
}

export type EnumFontStyleButton = EnumFontStyle.LIGHT | EnumFontStyle.REGULAR | EnumFontStyle.SOLID;
